import { useState, useEffect } from "react";

export default function useAuth() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const saved = localStorage.getItem("hive_authenticated");
    const userJson = localStorage.getItem("hive_user");

    if (saved === "true") {
      setIsAuthenticated(true);
      if (userJson) {
        setUser(JSON.parse(userJson));
      }
    }
  }, []);

  const login = (userData) => {
    localStorage.setItem("hive_authenticated", "true");
    localStorage.setItem("hive_user", JSON.stringify(userData));

    const maybeSet = (key, value) => {
      if (value == null) return;
      const existing = localStorage.getItem(key);
      if (existing === null) {
        const toStore =
          typeof value === "object" ? JSON.stringify(value) : value;
        localStorage.setItem(key, toStore);
      }
    };

    // Protein
    maybeSet("custom.hyman_hive_start_date", userData?.proteinStartDate);
    maybeSet("custom.hyman_hive_log", userData?.proteinLog);

    // Mood
    maybeSet("custom.hyman_hive_mood_start_date", userData?.moodStartDate);
    maybeSet("custom.hyman_hive_mood_log", userData?.moodLog);

    // Hydration
    maybeSet(
      "custom.hyman_hive_hydration_start_date",
      userData?.hydrationStartDate
    );
    maybeSet("custom.hyman_hive_hydration_log", userData?.hydrationLog);

    // Sleep
    maybeSet("custom.hyman_hive_sleep_start_date", userData?.sleepStartDate);
    maybeSet("custom.hyman_hive_sleep_log", userData?.sleepLog);

    // Movement
    maybeSet(
      "custom.hyman_hive_movement_start_date",
      userData?.movementStartDate
    );
    maybeSet("custom.hyman_hive_movement_log", userData?.movementLog);

    // Meditation
    maybeSet(
      "custom.hyman_hive_meditation_start_date",
      userData?.meditationStartDate
    );
    maybeSet("custom.hyman_hive_meditation_log", userData?.meditationLog);

    setIsAuthenticated(true);
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem("hive_authenticated");
    localStorage.removeItem("hive_user");
    setIsAuthenticated(false);
    setUser(null);
  };

  return {
    isAuthenticated,
    login,
    logout,
    user,
  };
}
